import React from 'react';
// import flexible from '../../utils/flexible';
import '../rentCar/index.less';

class FindSourceGoods extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    // document.title = '寻找货源';
    return (
        <div className="page_type_h5">
            <div id="rentCar">
                <section>
                    <p className="fj">寻找货源是绿色慧联为实现人、车、货闭环而开展的货源业务，公司将为有需要的司机提供稳定的货源，并已在下述城市提供货源业务，如有需要可咨询对应的业务联系人。</p>
                </section>
                <section>
                    <figure>
                        <img width="100%" src="https://image.tf56.com/dfs/group1/M00/6C/CB/CiFBClvWYF2AM7XpAAaEQyopepU410.png" />
                    </figure>
                </section>
                <section>
                    <p>目前已开通业务城市11个，分别为<b>杭州</b>、<b>成都</b>、<b>合肥</b>、<b>长沙</b>、<b>西安</b>、<b>深圳</b>、<b>南充</b>、<b>武汉</b>、<b>义乌</b>、<b>郑州</b>、<b>广州</b>。</p>
                </section>
                <section>
                    <table>
                        <thead>
                            <tr>
                                <th width="50%">城市</th>
                                <th width="50%">联系方式</th> 
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>杭州</td>
                                <td>
                                    <a href="tel:15558008702">周/<b>155 5800 8702</b></a>
                                </td>
                            </tr>
                            <tr>
                                <td>成都</td>
                                <td>
                                    <a href="tel:13981758296">邓/<b>139 8175 8296</b></a>
                                </td>
                            </tr>
                            <tr>
                                <td>合肥</td>
                                <td>
                                    <a href="tel:15855105272">杨/<b>158 5510 5272</b></a>
                                </td>
                            </tr>
                            <tr>
                                <td>长沙</td>
                                <td>
                                    <a href="tel:18505088333">李/<b>185 0508 8333</b></a>
                                </td>
                            </tr>
                            <tr>
                                <td>西安</td>
                                <td>
                                    <a href="tel:13571885188">朱/<b>135 7188 5188</b></a>
                                </td>
                            </tr>
                            <tr>
                                <td>深圳</td>
                                <td>
                                    <a href="tel:13480984596">杨/<b>134 8098 4596</b></a>
                                </td>
                            </tr>
                            <tr>
                                <td>南充</td>
                                <td>
                                    <a href="tel:13871686563">施/<b>138 7168 6563</b></a>
                                </td>
                            </tr>
                            <tr>
                                <td>武汉</td>
                                <td>
                                    <a href="tel:15207109652">李/<b>152 0710 9652</b></a>
                                </td>
                            </tr>
                            <tr>
                                <td>义乌</td>
                                <td>
                                    <a href="tel:18661520259">牛/<b>186 6152 0259</b></a>
                                </td>
                            </tr>
                            <tr>
                                <td>郑州</td>
                                <td>
                                    <a href="tel:15554731333">李/<b>155 5473 1333</b></a>
                                </td>
                            </tr>
                            <tr>
                                <td>广州</td>
                                <td>
                                    <a href="tel:18650849901">杨/<b>186 5084 9901</b></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
            </div>
        </div>
    );
  }
}

export default FindSourceGoods;



// WEBPACK FOOTER //
// ./src/staticPage/findSourceGoods/index.js